'use strict';

/**
* @description Initializes the slick slider carousels
*/

var slickCarousel = {

    /**
     * @function
     * @description - caches dom elements used as vars and returns an object
     */
    initCache: function() {
        var $cache = {
            slickElement: $('.slick-slider')
        };

        return $cache;
    },

    /**
     * @function
     * @description - initializes each instance of the carousel found, based on the param passed
     */
    initSlickSlider: function(element) {
        var $element = $(element);

        $element.each(function() {
            var $this = $(this);

            if ($this.hasClass('slick-initialized')) {
                return false;
            }

            $this.slick();
        });
    },

    init: function() {
        var $cache = this.initCache();

        if (!$cache.slickElement) {
            $cache.slickElement = $('.slick-slider');
        }

        this.initSlickSlider($cache.slickElement);
    }
};

module.exports = slickCarousel;
